import {Base, BaseConfiguration} from "../../services";
import {Component, ComponentConfiguration} from "../base";

export type LoadingIndicatorConfiguration = ComponentConfiguration & {
    container?: HTMLElement,
    disable_delay?: number
};

export class LoadingIndicator extends Component
{
    protected configuration: LoadingIndicatorConfiguration;
    protected element: HTMLElement;
    protected container: HTMLElement;

    constructor(...configurations: LoadingIndicatorConfiguration[])
    {
        const defaults: LoadingIndicatorConfiguration = {
            content_element: ".c-LoadingIndicator__loader",
            container: null,
            disable_delay: 1000,
        };

        super(defaults, ...configurations);
    }

    public build(): this
    {
        super.build();
        this.addClass("c-LoadingIndicator");

        return this;
    }


    public render(): string
    {
        return `<div>
                    <div class="c-LoadingIndicator__loader">
                        <div class="c-LoadingIndicator__spinner"></div>
                    </div>
                </div>`;
    }

    public loading(loading: boolean = true): this
    {
        this.container = this.configuration.container;

        if (!["absolute", "relative", "fixed"].includes(this.container.style.position))
        {
            this.container.style.position = "relative";
        }

        if (loading === false)
        {
            setTimeout(()=>
            {
                this.element.remove();
                setTimeout(() =>
                {
                    this.element.classList.remove("c-LoadingIndicator--active");
                }, 100);
            }, this.configuration.disable_delay)
        }
        else
        {
            this.container.appendChild(this.element);
            setTimeout(()=> {
                this.element.classList.add("c-LoadingIndicator--active");
            }, 100);
        }

        return this;
    }

    public setContainer(element: HTMLElement): this
    {
        this.container = element;
        return this;
    }
}
